import { Component, Injectable, Inject, NgModule, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthentificationDialog } from 'src/dialogs/authentification/authentification.dialog';
import { DConnexion } from 'src/dto/dialogClass/connexion';
import { Stay } from 'src/dto/stay';
import { Structure } from 'src/dto/structure';
import { User } from 'src/dto/user';
import { isNullOrUndefined } from 'util';
import { DialogCardComponent } from '../../shared/dialog-card/dialog-card.component';
import { UtilsFunctions } from '../../shared/functions/utils-functions';

@Component({
    selector: 'menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})


@Injectable()
export class MenuComponent {

    @Input() currentUser;
    @Input() currentStructure;

    @Output() currentUserParent: EventEmitter<any> = new EventEmitter<any>();
    menuSelected: string;

    menuItems = [
        { title: "Accueil", route: "/home" },
        { title: "Les séjours", route: "/stays-list" },
        { title: "Les organisateurs", route: "/structures" },
        //{ title: "Bons plans", route: "/" },
        //{ title: "Dernières minutes", route: "/" }
    ]

    constructor(public dialog: MatDialog, private router: Router) {

    }

    ngOnInit() {
        var currentUrl = window.location.href;
        this.menuSelected = "/" + currentUrl.split("/")[(currentUrl.split("/")).length - 1];
    }

    addStay() {
        if (this.currentUser == null) {
            const dialogCard = this.dialog.open(AuthentificationDialog, {
                width: '70%',
                height: '80%',
                panelClass: 'mat-dialog-any-padding',
                autoFocus: false
            });
            dialogCard.afterClosed().subscribe(async rslt => {
                if (!isNullOrUndefined(rslt)) {
                    this.currentUser = UtilsFunctions.SessionGetCurrentUser();
                    this.currentStructure = UtilsFunctions.SessionGetCurrentStructure();

                    this.currentUserParent.emit(this.currentUser);

                    if (this.currentUser.profil == User.PROFIL_DIRECTOR || this.currentUser.profil == User.PROFIL_COLLABORATEUR) {
                        this.router.navigate(["edit-stay"]);
                    }
                }
            });
        }

        if (this.currentUser.profil == User.PROFIL_DIRECTOR || this.currentUser.profil == User.PROFIL_COLLABORATEUR) {
            this.router.navigate(["edit-stay"]);
        }
    }
}